import { Header } from "../Header/Header";
import { Container } from "./SharedLayout.styled";
import { Outlet } from "react-router-dom";

export const SharedLayout = () => {
  return (
      <Container>
<Header />
    <Outlet />
   </Container>
  );
}